// extracted by mini-css-extract-plugin
export default {"tooltip":"TextWithTooltip_tooltip__l2V-l","tooltip_body":"TextWithTooltip_tooltip_body__-M4sN"};